<template>
  <div class="basic-block block-about-slider-base" :style="styles">
    <div class="content-wrap">
      <div class="block-about-slider-base__inner">
        <h3 class="block-about-slider-base__headline">姓名と誕生日でわかる<br>あなたの本当のこと</h3>
        <img :src="`${path}title_houou.png`" alt="" class="block-about-slider-base__headline-img" />
        <div class="block-about-slider-base__profile">
          <img class="block-about-slider-base__profile-img" :src="`${path}counselor7.png`" alt="" />
          <p class="block-about-slider-base__profile-text">
            複数の占術をかけあわせることで導かれる人の本質や秘められた可能性、人生の使命を81種の動物であらわしたのが鳳凰数術です。
          </p>
        </div>
      </div>

      <div class="block-about-slider-base__sliderarea">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(item, idx) of sliderList" :key="idx">
            <img :src="item.src" class="block-about-slider-base__slider-card" :alt="item.alt" />
          </swiper-slide>
        </swiper>
      </div>

      <p class="block-about-slider-base__free">あなたについて、<br>暮れの酉はどんな見立てを<br>行うのでしょうか？</p>
      <lp-base-button label="自分のタイプを占う" design="fill" :color-scheme="colorScheme" @clicked="clicked" />
    </div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

export default {
  name: 'BlockAboutSlider',
  components: {
    LpBaseButton,
    swiper,
    swiperSlide,
  },
  props: {
    targetInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    colorScheme: {
      type: Object,
      default() {
        return {};
      },
    },
    lpId: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    styles() {
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      };
    },
  },
  methods: {
    clicked() {
      window.gtag('event', 'click', {
        event_category: `LP${this.lpId}-free-shindan-button`,
      });
      location.href = this.$handoverParams(`/recommend/lp/${this.lpId}/basic/input`);
    },
  },
  data() {
    return {
      path: '/static/img/recommend/lp/kurenotori/',
      swiperOption: {
        speed: 600,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        loop: true,
      },
      sliderList: [
        {
          src: '/static/img/recommend/lp/kurenotori/talent_sample1.png',
          alt: 'ゴールデンボンバー・鬼龍院翔さんは、考えすぎのイルカ',
        },
        {
          src: '/static/img/recommend/lp/kurenotori/talent_sample2.png',
          alt: 'ジャニーズWEST・神山智洋さんは、さみしがりな龍',
        },
        {
          src: '/static/img/recommend/lp/kurenotori/talent_sample3.png',
          alt: '大人気YouTuber・ゆきりぬさんは、わが道をいく孔雀',
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
@import '../../../../../../../../sass/commons/commonVariables.scss';

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

// 上限付きのレスポンシブなサイズを返す（$size は、width = 375px 時の大きさ）
@function responsive-size($size) {
  @return Min(($size / 375) * 100vw, $size * 1.3px );
}

.block-about-slider-base {
  background: 
    url('/static/img/recommend/lp/kurenotori/bg_tori_title.png') no-repeat 50% 40px/100% auto,
    url('/static/img/recommend/lp/kurenotori/bg_tori_title.png') no-repeat 50% calc(100% - 24px)/100% auto 
    #F3FEFF;
  padding: 40px 0 78px;
  &__headline {
    font-weight: 600;
    font-size: responsive-size(20);
    line-height: 1.5;
    text-align: center;
    color: $l_col_keycolor;
    margin: 0 0 8px;
  }
  &__headline-img {
    display: block;
    width: responsive-size(160);
    max-width: 100%;
    margin: 0 auto 24px;
  }
  &__profile {
    display: flex;
    align-items: center;
    max-width: 480px;
    margin: 0 auto 16px;
  }
  &__profile-img {
    flex: 0 1 160px;
    width: responsive-size(160);
    max-width: 200px;
  }
  &__profile-text {
    flex: 1 1 auto;
    margin: -3% 0 0;
    font-weight: 300;
    font-size: responsive-size(16);
    line-height: 1.62;
    color: $l_col_keycolor;
  }
  &__sliderarea {
    margin: 0 0 24px;
    .swiper-slide {
      padding: 0 20px;
    }
  }
  &__slider-card {
    display: block;
    width: 100%;
    max-width: 480px;
    margin: auto;
  }
  &__free {
    font-weight: 600;
    font-size: responsive-size(20);
    line-height: 1.5;
    text-align: center;
    color: $l_col_keycolor;
    margin: 0 0 24px;
  }
  .baseButton {
    width: 72%;
    max-width: 340px;
    margin: auto;
    /deep/ {
      .baseButton__button {
        font-size: responsive-size(18);
        font-weight: 600;
        padding: 13.5px 32px;
        min-width: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kurenotori/blocks/BlockAboutSlider.vue